<!--
 * @Descripttion: 我的审批
 * @Author: chenjinsheng
 * @Date: 2021-08-30 14:31:27
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-24 18:05:47
-->
<template>
    <div class="approval-list-container">
        <div class="menu-tab-title">
            <div class="menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-badge :value="countList.todoCount" class="item" :max="99" :hidden="countList.todoCount === 0">
                        <el-menu-item index="0">待审</el-menu-item>
                    </el-badge>
                    <el-badge :value="countList.taskCount" class="item" :max="99" :hidden="countList.taskCount === 0">
                        <div :class="{ 'guide-work-container': steps.step3 }">
                            <el-menu-item index="5" class="">工作沟通</el-menu-item>
                        </div>
                    </el-badge>
                    <el-badge
                        :value="countList.unreadCount"
                        class="item"
                        :max="99"
                        :hidden="countList.unreadCount === 0"
                    >
                        <el-menu-item index="1">待阅</el-menu-item>
                    </el-badge>
                    <el-badge :value="0" class="item" :hidden="true">
                        <el-menu-item index="4">已处理</el-menu-item>
                    </el-badge>
                    <el-badge :value="0" class="item" :hidden="true">
                        <el-menu-item index="6">我发起</el-menu-item>
                    </el-badge>
                    <el-badge :value="0" class="item" :hidden="true">
                        <el-menu-item index="7">流程草稿</el-menu-item>
                    </el-badge>
                    <el-badge :value="countList.collectCount" class="item" :max="99" :hidden="true">
                        <el-menu-item index="9">收藏流程</el-menu-item>
                    </el-badge>
                </el-menu>
            </div>

            <div class="search-box">
                <div v-show="!isDraft" class="input-search">
                    <i class="el-icon-search"></i>
                    <el-input v-model="title" placeholder="标题、发起人搜索" size="mini" @input="goSearch"> </el-input>
                </div>
                <el-button type="mini" class="btn-refresh" @click="refresh('search')">
                    <img src="@/assets/pics/refresh.png" alt="" :class="['sx-btn', { revolve: reRotate }]" />
                </el-button>
            </div>
        </div>
        <!-- 我的审批列表 -->
        <to-do-app ref="toDoApp" :visible="isApp" />
        <!-- 已发起列表 -->
        <to-do-flow ref="toDoFlow" :visible="isFlow" />
        <!-- 流程草稿列表 -->
        <to-do-draft ref="toDoDraft" :visible="isDraft" />
        <!-- 收藏流程列表 -->
        <to-do-collect ref="toDoCollect" :visible="isCollect" @reload="refresh" />
    </div>
</template>

<script>
import ToDoApp from "./to-do-app";
import ToDoDraft from "./to-do-draft";
import ToDoFlow from "./to-do-flow";
import ToDoCollect from "./to-do-collect";
import { searchApprovalNum } from "@/api";
import { mapState } from "vuex";
import { openWebSocket } from "@/libs/websocket";
import { getLocalStorage } from "@/libs/mUtils";
export default {
    name: "ApprovalList",
    components: {
        ToDoApp,
        ToDoFlow,
        ToDoDraft,
        ToDoCollect,
    },
    data() {
        return {
            reRotate: false,
            title: "",
            activeIndex: "0",
            countList: {
                doneCount: 0,
                readCount: 0,
                todoCount: 0,
                unreadCount: 0,
                taskCount: 0,
                collectCount: 0,
            },
            isApp: true, // 审批
            isFlow: false, // 我发起
            isDraft: false, // 流程草稿
            isCollect: false, // 收藏流程
        };
    },
    computed: {
        ...mapState({
            switch: (state) => state.guide.switch,
            steps: (state) => state.guide.steps,
        }),
    },
    mounted() {
        this.init();
        this.openWebsocket();
        this.tabListener();
    },
    methods: {
        init() {
            this.$refs.toDoApp.loadData();
            this.queryAppNum();
        },
        tabListener() {
            document.addEventListener("visibilitychange", () => {
                if (document.visibilityState === "hidden") {
                    //切离该页面时执行
                } else if (document.visibilityState === "visible") {
                    //切换到该页面时执行
                    let title = localStorage.getItem("title");
                    this.title = title;
                    // 做防抖
                    this.refreshTimer && clearTimeout(this.refreshTimer);
                    this.refreshTimer = setTimeout(() => {
                        this.refresh();
                    }, 2000);
                }
            });
        },

        // 刷新

        refresh(e) {
            if (e && e === "search") {
                this.title = "";
                localStorage.setItem("title", this.title);
                if (this.isApp) {
                    this.$refs.toDoApp &&
                        this.$refs.toDoApp.changeSearchOps({
                            title: this.title,
                        });
                }

                if (this.isFlow) {
                    this.$refs.toDoFlow &&
                        this.$refs.toDoFlow.changeSearchOps({
                            title: this.title,
                        });
                }

                if (this.isDraft) {
                    this.$refs.toDoDraft &&
                        this.$refs.toDoDraft.changeSearchOps({
                            title: this.title,
                        });
                }

                if (this.isCollect) {
                    this.$refs.toDoCollect &&
                        this.$refs.toDoCollect.changeSearchOps({
                            title: this.title,
                        });
                }
            }
            if (this.isApp) {
                this.$refs.toDoApp && this.$refs.toDoApp.refresh();
            }

            if (this.isFlow) {
                this.$refs.toDoFlow && this.$refs.toDoFlow.refresh();
            }

            if (this.isDraft) {
                this.$refs.toDoDraft && this.$refs.toDoDraft.refresh();
            }

            if (this.isCollect) {
                this.$refs.toDoCollect && this.$refs.toDoCollect.refresh();
            }
            this.queryAppNum();
            this.rotate();
        },
        rotate() {
            this.reRotate = true;
            setTimeout(() => {
                this.reRotate = false;
            }, 500);
        },
        goSearch() {
            localStorage.setItem("title", this.title);
            if (this.isApp) {
                // 发起审批
                this.loadData("toDoApp");
                return;
            }

            if (this.isFlow) {
                // 发起流程
                this.loadData("toDoFlow");
                return;
            }

            if (this.isDraft) {
                // 流程草稿
                this.loadData("toDoDraft");
                return;
            }

            if (this.isCollect) {
                // 收藏流程
                this.loadData("toDoCollect");
                return;
            }
        },
        loadData(formRef) {
            // localStorage.setItem("title", this.title);
            this.$refs[formRef].changeSearchOps({
                title: this.title,
            });
            this.$refs[formRef].loadData();
        },
        // 查询审批数量
        async queryAppNum() {
            try {
                const { body, code, message } = await searchApprovalNum();
                if (code === "0000") {
                    const { doneCount, readCount, todoCount, unreadCount, collectCount, communicateTodoCount } = body;
                    this.countList.doneCount = doneCount;
                    this.countList.readCount = readCount;
                    this.countList.todoCount = todoCount;
                    this.countList.unreadCount = unreadCount;
                    this.countList.collectCount = collectCount;
                    this.countList.taskCount = communicateTodoCount;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
        /**
         * @description:  菜单切换
         * @param {*} key 0-待审；5-工作沟通；1待阅；4-已处理；6-我发起；7-流程草稿
         * @return {*}
         */
        handleSelect(key) {
            const type = parseInt(key);
            // taskType: 0, // 0-普通任务；1-工作沟通
            // handleType: 0, // 0-待办；1-待阅；2-已办；3-已阅;  4-已处理
            if (type === 5) {
                // 工作沟通
                this.$refs.toDoApp &&
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 1,
                        handleType: 0,
                        handleGroup: "ALL",
                    });
                this.changeStatus(true, false, false, false);
                this.$emit("more", 5);
                this.$refs.toDoApp && this.$refs.toDoApp.loadData();
            } else if (type === 6) {
                // 我发起
                this.changeStatus(false, true, false, false);
                this.$refs.toDoFlow && this.$refs.toDoFlow.loadData();
                this.$emit("more", 6);
            } else if (type === 7) {
                // 流程草稿
                this.changeStatus(false, false, true, false);
                this.$refs.toDoDraft && this.$refs.toDoDraft.loadData();
                this.$emit("more", 7);
            } else if (type === 9) {
                // 收藏流程
                this.changeStatus(false, false, false, true);
                this.$refs.toDoCollect && this.$refs.toDoCollect.loadData();
                this.$emit("more", 9);
            } else if (type === 4) {
                // 已处理
                this.changeStatus(true, false, false, false);
                this.$refs.toDoApp &&
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 0,
                        handleType: 4,
                        handleGroup: "ALL",
                    });
                this.$refs.toDoApp && this.$refs.toDoApp.loadData();
                this.$emit("more", 2);
            } else {
                this.changeStatus(true, false, false, false);
                this.$refs.toDoApp &&
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 0,
                        handleType: type,
                        handleGroup: "ALL",
                    });
                this.$emit("more", type);
                this.$refs.toDoApp && this.$refs.toDoApp.loadData();
            }
            this.queryAppNum();
        },
        changeStatus(isApp, isFlow, isDraft, isCollect) {
            this.isApp = isApp;
            this.isFlow = isFlow;
            this.isDraft = isDraft;
            this.isCollect = isCollect;
        },

        /**
         * 启动 websocket
         * url：websocket 请求地址
         * websocketMessage：接收参数的回调方法
         */
        openWebsocket() {
            const auth_user = getLocalStorage("user");
            const username = auth_user.oauth.userName;
            // let url = 'ws://192.168.1.77:7100/mc/websocket'
            let domain = this.$config.baseURL.replace("https:", "").replace("http:", "");
            let url = `ws:${domain}/publisher/socket/${username}`;
            openWebSocket(url, this.websocketMessage);
        },

        /**
         * websocket 回调方法
         * type: 1 连接成功，2 接收到消息，3 连接错误，4 连接关闭
         * data: 当 type 为 2 时，接收到的返回数据
         */
        websocketMessage(type, data) {
            if (type === "success") {
                console.log("socket连接成功！！！");
            } else if (type === "message") {
                console.log("获取消息成功！！！", data.event);
                // 刷新用户审批数据
                if (data.event === "APPROVAL_MSG") {
                    console.log("websocket");
                    this.refresh();
                }
            } else if (type === "err") {
                console.warn("WebSocket连接发生错误");
                // this.$message.warning('WebSocket连接发生错误')
            } else if (type === "close") {
                console.warn("WebSocket连接关闭");
                // this.$message.warning('WebSocket连接关闭')
            }
        },
        beforeDestroy() {
            document.removeEventListener("visibilitychange", () => {});
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
